import { findMessage } from '..';
import Styles from './assets/style.scss';
import EmptyIcon from './components/EmptyIcon';
import { IEmpty } from './entities';

const BCEmpty = (props: IEmpty) => (
	<div
		className={[Styles.empty, props.className].join(' ')}
		style={props.style}
	>
		<div className="darkEmptyBox">
			<EmptyIcon theme="dark" />
		</div>
		<div className="lightEmptyBox">
			<EmptyIcon theme="light" />
		</div>
		<p>{props.description || findMessage.get('100702')}</p>
		{props.children}
	</div>
);
export default BCEmpty;
export { IEmpty };
